import { AppThunk } from '../../../store/rootReducer';
import { ecgIdSelector } from '../../ecg/selectors/ecg.selectors';
import * as clusterActions from '../actions/cluster.actions';
import * as morphologyActions from '../actions/morphology.actions';
import { merge } from '../client/cluster.client';
import { Cluster } from '../clustering.types';
import { unmergedClustersSelector } from '../selectors/cluster.selectors';
import { morphologiesSelector } from '../selectors/morphology.selectors';
import { displayNotification } from '../../../shared/notification/display-notification';

export const mergeClusters =
  (clusters: Cluster[], morphology: Cluster | null = null): AppThunk =>
  async (dispatch, getState) => {
    const ecgId = ecgIdSelector(getState());
    if (ecgId == null) {
      return null;
    }
    const morphologies = morphologiesSelector(getState());
    const unmergedClusters = unmergedClustersSelector(getState());
    const clusterIds = clusters.map((cluster) => cluster.id);
    if (morphology != null) {
      clusterIds.push(morphology.id);
    }
    const mergedClusterId = await merge(ecgId, clusterIds);
    if (mergedClusterId == null) {
      return;
    }
    const beats = clusters.flatMap((cluster) => cluster.beats);
    if (morphology != null) {
      beats.push(...morphology.beats);
    }
    const mergedCluster: Cluster = {
      id: mergedClusterId,
      classification: clusters[0].classification,
      priority: morphology?.priority ?? morphologies.length,
      beats,
    };

    dispatch(
      morphologyActions.replaceMorphology({
        newMorphology: mergedCluster,
        oldMorphology: morphology,
      }),
    );
    dispatch(
      clusterActions.removeClusters({
        clusterIds: clusters.map((cluster) => cluster.id),
      }),
    );

    if (unmergedClusters.length === 0) {
      displayNotification({
        title: 'Task completed',
        status: 'success',
      });
    }
  };
